import Badge from 'components/badge/Badge';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { InternalIntegrationSetting } from 'models/InternalIntegrationSetting';
import usePropertySettingsInitData from 'pages/property/usePropertySettingsInitData';
import { useTranslation } from 'react-i18next';
import theme from 'styles/theme';
import { ActionsWrapper } from './ChannelListItem.styles';
import ChannelToggle from './ChannelToggle';
import ManageChannelLink from './ManageChannelLink';
import useToggleChannel from './useToggleChannel';
import ViewListingLink from './ViewListingLink';

const Actions = ({
  integration,
}: {
  integration: InternalIntegrationSetting;
}) => {
  const { enumId } = integration;

  const { t } = useTranslation();
  const { property, isLoading: isLoadingProperty } =
    usePropertySettingsInitData();
  const {
    isActive,
    isPending,
    handleToggle,
    isLoading: isLoadingToggle,
    isUpdating,
    propertySetting,
  } = useToggleChannel({
    enumId,
    propertyUid: property?.uid ?? '',
  });

  const isLoading = isLoadingProperty || isLoadingToggle;

  if (isLoading) {
    return (
      <ActionsWrapper>
        <LoadingPlaceholder width="62px" linesCount={2} />
      </ActionsWrapper>
    );
  }

  return (
    <ActionsWrapper>
      <ManageChannelLink integration={integration.integration} />
      <ViewListingLink publicLink={propertySetting?.publicLink ?? null} />

      {isPending ? (
        <Badge
          backgroundColor={theme.colors.hostfullyYellow}
          data-testid="pending-status"
        >
          {t('pageProperty.channels.pending')}
        </Badge>
      ) : (
        <ChannelToggle
          integration={integration}
          propertyBusinessType={property?.businessType!}
          isActive={isActive}
          handleToggle={handleToggle}
          isUpdating={isUpdating}
        />
      )}
    </ActionsWrapper>
  );
};

export default Actions;
